export const setAsyncTimeout = (cb: () => void, timeout = 0) =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      cb();
      resolve();
    }, timeout);
  });
